export interface CustomerTradeGroup {
  id: string;
  key: string;
  description: string;
  createCustomer: boolean;
  createCustomerString: string;
  discountPercentage: number;
}
